import React, { useEffect, useState } from "react";
import CardBox from "../common/CardBox";
import { Link } from "react-router-dom";
import {
  Avatar,
  Button,
  Card,
  DatePicker,
  Flex,
  Form,
  GetProp,
  Grid,
  Input,
  Select,
  Space,
  Table,
  TableProps,
  Tag,
  Typography,
} from "antd";
import {
  SearchOutlined,
  CloseOutlined,
  PlusOutlined,
  HomeOutlined,
  HomeTwoTone,
  ShopOutlined,
  CoffeeOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { ColumnsType, SorterResult } from "antd/es/table/interface";
import qs from "qs";
import CommonDataTable from "../common/CommonDataTable";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

interface DataType {
  name: {
    first: string;
    last: string;
  };
  gender: string;
  email: string;
  login: {
    uuid: string;
  };
}

interface TableParams {
  pagination?: any;
  sortField?: SorterResult<any>["field"];
  sortOrder?: SorterResult<any>["order"];
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}
const { Title, Text } = Typography;
const columns: ColumnsType<DataType> = [
  {
    title: "Booking Number",
    dataIndex: "booking_number",
    sorter: true,
    render: (booking_number) => `${booking_number}`,
    width: "20%",
  },
  {
    title: "Email",
    dataIndex: "email",
    filters: [
      { text: "Male", value: "male" },
      { text: "Female", value: "female" },
    ],
    width: "20%",
  },
  {
    title: "Customer Name",
    dataIndex: "text",
  },
  {
    title: "Created On",
    dataIndex: "text",
  },
  {
    title: "Booking Status",
    dataIndex: "text",
  },
  {
    title: "",
    dataIndex: "Action",
  },
];

const getRandomuserParams = (params: TableParams) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const SearchBooking = () => {
  const [form] = Form.useForm();
  const [clientReady, setClientReady] = useState<boolean>(false);

  // To disable submit button at the beginning.
  useEffect(() => {
    setClientReady(true);
  }, []);

  const onFinish = (values: any) => {
    console.log("Finish:", values);
  };
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      <Form
        form={form}
        name="search_booking"
        className="gap-16 align-end"
        layout="inline"
        onFinish={onFinish}
      >
        <Form.Item
          className="filterTextfieldBox"
          label="Booking Date From"
          rules={[{ required: true, message: "Please select created from!" }]}
        >
          <DatePicker className="searchInputField" />
        </Form.Item>

        <Form.Item
          className="filterTextfieldBox"
          label="Booking Date To"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <DatePicker className="searchInputField" />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Reference Number"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input className="searchInputField" />
        </Form.Item>

        <Form.Item
          className="filterTextfieldBox"
          label="Application status"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Select
            className="searchInputField"
            defaultValue="All"
            options={[
              { value: "All", label: "All" },
              { value: "Sent for Approval", label: "Sent for Approval" },
              { value: "Returned", label: "Returned" },
              { value: "Application Accepted", label: "Application Accepted" },
              { value: "Sent for Approval", label: "Sent for Approval" },
            ]}
          />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox twoColumForm"
          label="Search by name, passport/Application Number"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input className="searchInputField" />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Visa Type"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Select
            className="searchInputField"
            defaultValue="All"
            options={[{ value: "All", label: "All" }]}
          />
        </Form.Item>
        <Form.Item shouldUpdate>
          {() => (
            <Button type="primary" size="large" danger className="px-5">
              Search
            </Button>
          )}
        </Form.Item>
      </Form>

      <div>
        {isVisible && (
          <Card>
            <Form
              form={form}
              name="search_booking"
              className="search_booking"
              layout="inline"
            >
              <Form.Item
                label="Service Type"
                name="serviceType"
                className="filterTextfieldBox"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "All", label: "All" },
                    { value: "Hotel", label: "Hotel" },
                    { value: "Activities", label: "Activities" },
                    { value: "Meal", label: "Meal" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label="Payment Type"
                name="paymentType"
                className="filterTextfieldBox"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "All", label: "All" },
                    { value: "Credit Limit", label: "Credit Limit" },
                    { value: "Activities", label: "Activities" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                className="filterTextfieldBox"
                label="Agent & SubAgent"
                name="agentSubAgent"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "All", label: "All" },
                    { value: "SUB_mridul", label: "SUB_mridul" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                className="filterTextfieldBox"
                label="Source"
                name="source"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "All", label: "All" },
                    { value: "Website", label: "Website" },
                    { value: "Mobile", label: "Mobile" },
                  ]}
                />
              </Form.Item>
              <Form.Item
                className="filterTextfieldBox"
                label="Record Per Page"
                name="recordPerPage"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "50", label: "50" },
                    { value: "100", label: "100" },
                    { value: "500", label: "500" },
                  ]}
                />
              </Form.Item>
              <Form.Item className="d-flex align-end mr-0">
                <Button type="primary" htmlType="submit">
                  Advance Search
                </Button>
              </Form.Item>
            </Form>
          </Card>
        )}
      </div>
    </>
  );
};

const BookingData = () => {
  const navigate = useNavigate();

  const onRowClick = (event: any) => {
    navigate("/home/booking/edit");
  };
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const setAgeSort = () => {
    setSortedInfo({
      order: "descend",
      columnKey: "age",
    });
  };
  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Select",
      dataIndex: "select",
      key: "select",
    },
    {
      title: "Agent Name",
      dataIndex: "agentName",
      key: "agentName",
    },
    {
      title: "Ref. Number",
      dataIndex: "refNumber",
      key: "refNumber",
    },
    {
      title: "Visa Type",
      dataIndex: "visaType",
      key: "agentReferenceNumber",
    },
    {
      title: "Applicant Name",
      dataIndex: "applicantName",
      key: "applicantName",
    },
    {
      title: "Passport Number",
      dataIndex: "passportNumber",
      key: "passportNumber",
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
    },
    {
      title: "Application Number",
      dataIndex: "applicationNumber",
      key: "applicationNumber",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Upload Documents",
      dataIndex: "uploadDocuments",
      key: "uploadDocuments",
    },
    {
      title: "Download Documents",
      dataIndex: "downloadDocuments",
      key: "downloadDocuments",
    },
    {
      title: "View Details",
      dataIndex: "viewDetails",
      key: "viewDetails",
    },
  ];

    const columnsMobile = [
      {
        dataIndex: "details",
        key: "details",
        render: (_: any, record: any) => {
          // Filter out 'adult', 'child', and 'infant' if their value is "0"
          const filteredData = Object.entries(record).filter(([key, value]) => {
            return !(
              (key === "adult" || key === "child" || key === "infant") &&
              value === "0"
            );
          });
    
          return (
            <div className="mobile-card">
              {filteredData.map(([key, value]) => {
                // Show bookingDate and travelDate in one row
                if (key === "bookingDate") {
                  return (
                    <p key={key}>
                      <strong>Booking & Travel Date: </strong>
                      {value} → {record.travelDate}
                    </p>
                  );
                }
                if (key === "travelDate") return null; // Hide separate travelDate entry
    
                return (
                  <p key={key}>
                    <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
                    {React.isValidElement(value) ? value : String(value)}
                  </p>
                );
              })}
            </div>
          );
        },
      },
    ];

  const data = [
    { 
      select: "John Brown",
      agentName: "AGT-900",
      refNumber: "AGT0900",
      visaType: "Visa",
      applicantName: "ETMKT980990",
      passportNumber: "123456",
      createdDate: "30/04/2022",
      applicationNumber: "3447567",
      status: "Mr. Gharju",
      uploadDocuments: "2",
      downloadDocuments: "0",
      viewDetails: "viewDetails",
    },
    { 
      select: "John Brown",
      agentName: "AGT-900",
      refNumber: "AGT0900",
      visaType: "Visa",
      applicantName: "ETMKT980990",
      passportNumber: "123456",
      createdDate: "30/04/2022",
      applicationNumber: "3447567",
      status: "Mr. Gharju",
      uploadDocuments: "2",
      downloadDocuments: "0",
      viewDetails: "viewDetails",
    },
  ];
  const { useBreakpoint } = Grid; // Correct way to use it
  const screens = useBreakpoint(); // Ensures screens is defined
  return (
    <>
      <Table
        bordered
        columns={screens.lg ? columns : columnsMobile}
        dataSource={data}
        onChange={handleChange}
        className="mt-4 responsiveTable"
      />
    </>
  );
};

export const MyVisa = () => {
   const [searchBookingIsVisible, setSearchBookingIsVisible] = useState(false);
  return (
    <CardBox
      title={
        <Typography.Title
          level={2}
          color="danger"
          className="mb-0 mt-0 primary-color font-weight-700"
        >
          Travel &nbsp;
          <Text type="danger" className="header-font-title">
            Authorization
          </Text>
        </Typography.Title>
      }
    >
      <div
        className={`drawer-box ${searchBookingIsVisible ? "drawerActive" : ""}`}
      >
        <Card className="topBox transition-all duration-300 ease-in-out">
          <SearchBooking />
        </Card>

        <Button
          className="slideButton"
          onClick={() => setSearchBookingIsVisible(!searchBookingIsVisible)}
        >
          {searchBookingIsVisible ? (
            <ChevronUp size={20} />
          ) : (
            <ChevronDown size={20} />
          )}
        </Button>
      </div>
      
        <Text type="secondary" className="d-block mb-2">
          Showing 1 to 10 of 800 records
        </Text>
        <BookingData />
       
    </CardBox>
  );
};

export default MyVisa;
